import { useParams } from "react-router-dom";
import { useQueryClient } from "react-query";

export default function useSections(){

    const {course} = useParams();

    const queryClient = useQueryClient();

    const data = queryClient.getQueryData(course);

    return data.chapters.reduce((a,b) => a.concat(b.sections), []);

}